import { Product } from "#/common/interfaces/conversionworld/Product";
// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Components
import Overview from "./overview/Overview";
import Configuration from "./configuration/Configuration";
import Solution from "./solution/Solution";
import Galery from "./galery/Galery";
@Component({
  mixins: [template],
  components: {
    Overview,
    Configuration,
    Solution,
    Galery,
  },
})
export default class KonsiDetailLayer extends Vue {
  activeTab = "overview";
  headerElement;
  headerHeight = 183;
  showMap = false;
  mapHeight = 460;

  @Prop()
  konsi!: object;

  @Prop()
  translation!: object;

  created() {}

  mounted() {
    this.headerElement = <HTMLElement>this.$refs["header"];
    window.addEventListener("resize", this.handleResize);
    this.calcHeaderSize();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }

  public handleResize(event) {
    this.calcHeaderSize();
  }

  private calcHeaderSize() {
    this.headerHeight = this.headerElement.getBoundingClientRect().height + 70;
    this.mapHeight = window.innerHeight - this.headerHeight;
    if (window.innerWidth < 768) this.mapHeight = 200;
  }

  public handleClose() {
    this.$emit("close");
  }

  public handleShowMap($event) {
    $event.preventDefault();
    this.showMap = !this.showMap;
  }
}
